document.addEventListener('DOMContentLoaded',function(){
  var sizeType = document.querySelectorAll('.sizeTypeInit'), productSelector = document.querySelector('.sizeProductBasedWrpr'), how_measure = document.querySelector('.howToMeasureWrpr'),
      closeHow_measure = document.querySelector('.SizeItemBlkInit.active .OnClick-cross-popup'), body_click = document.body,
      seeINSize = document.querySelectorAll('.customSeeInSizeChart .tool-tip-trigger__title'), closeSeeInSize = document.querySelectorAll('.closeSizePop');
  if(sizeType.length > 0){
    sizeType.forEach(function(size){
      size.addEventListener('click',function(e){
        e.preventDefault();
        var dataSizeType=this.dataset.sizetype;
        sizeType.forEach(function(type){ type.classList.remove('active'); })
        this.classList.add('active');
        if(this.classList.contains('sizeTypeInch')){
          document.querySelectorAll('.InchesTable').forEach((chart) =>{chart.classList.add('active');})
          document.querySelectorAll('.CentiTable').forEach((chart) =>{chart.classList.remove('active');})
        }else if(this.classList.contains('sizeTypeCenti')){
          document.querySelectorAll('.InchesTable').forEach((chart) =>{chart.classList.remove('active');})
          document.querySelectorAll('.CentiTable').forEach((chart) =>{chart.classList.add('active');})
        }
      })
    })
  }
  if(productSelector){
    productSelector.addEventListener('change',function(){
      var targetProduct = this.value;
      document.querySelectorAll('.SizeItemBlkInit').forEach((productblock) =>{ productblock.classList.remove('active'); })
      document.querySelector('#'+targetProduct).classList.add('active');
      function scrollToTargetAdjusted(){
        var element = document.querySelector('#'+targetProduct);
        if(window.innerWidth > 749){
          var headerOffset = 300;
        }else{
          var headerOffset = 60;
        }
        var elementPosition = element.getBoundingClientRect().top;
        var offsetPosition = elementPosition + window.pageYOffset - headerOffset;
        
        window.scrollTo({
             top: offsetPosition,
             behavior: "smooth"
        });
      }
      scrollToTargetAdjusted();
    })
  }
  if(how_measure){
    how_measure.addEventListener('click',function(e){
      e.preventDefault();
      document.body.classList.add('HowMeasure');
      document.querySelector('.SizeItemBlkInit.active .Append-measure').style.display = 'block';
    })
  }
  if(closeHow_measure){
    closeHow_measure.addEventListener('click',function(e){
      e.preventDefault();
      document.body.classList.remove('HowMeasure');
      document.querySelector('.SizeItemBlkInit.active .Append-measure').style.display = 'none';
    })
  }
  if(body_click){
    body_click.addEventListener('click',function(e){
      if(!e.target.closest('.staticOuter') && !e.target.closest('.howToMeasureWrpr')){
        document.body.classList.remove('HowMeasure');
        if(document.querySelector('.SizeItemBlkInit.active .Append-measure')){
          document.querySelector('.SizeItemBlkInit.active .Append-measure').style.display = 'none';
        }
      }
      if(!e.target.closest('.customSeeInSizeChart tool-tip-trigger') && !e.target.closest('.tool-tip-trigger__content')){
        document.body.classList.remove('seeInSizeChart');
        document.querySelectorAll('.tool-tip-trigger__content').forEach(function(size){
          size.classList.remove('active');
        })
      }
    })
  }
})